import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"basket-2, shopping-bag"} maskId="square-filled-radius-0-stroke-1-IconBasket2"><path d="M6.73875 7.99954L8.65017 3.221L7.72169 2.84961L5.66154 8H1.91016L4.07682 21H19.924L22.0906 8H18.3389L16.2788 2.84961L15.3503 3.221L17.2617 7.99954H6.73875Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBasket2;
